"use strict";

var _vue = require("vue");

var _vue2 = _interopRequireDefault(_vue);

var _vue2GoogleMaps = require("vue2-google-maps");

var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);

var _vueVideoPlayer = require("vue-video-player");

var _vueVideoPlayer2 = _interopRequireDefault(_vueVideoPlayer);

require("element-ui/lib/theme-default/index.css");

var _vueAsyncComputed = require("vue-async-computed/dist/vue-async-computed");

var _vueAsyncComputed2 = _interopRequireDefault(_vueAsyncComputed);

require("script-loader!../node_modules/aos/dist/aos.js");

require("./assets/styles/app.sass");

require("script-loader!../node_modules/jquery/dist/jquery.js");

var _DefaultLayout = require("./layouts/default/DefaultLayout.vue");

var _DefaultLayout2 = _interopRequireDefault(_DefaultLayout);

var _FarmPage = require("./pages/farm/FarmPage.vue");

var _FarmPage2 = _interopRequireDefault(_FarmPage);

var _vueRouter = require("vue-router");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Vendors
_vue2.default.use(VueGoogleMaps, {
    load: {
        key: window.GLOBAL_CONFIG.googleMapKey
        // v: "OPTIONAL VERSION NUMBER"
        // libraries: 'places', //// If you need to use place input
    }
}); // Main Lib

_vue2.default.use(_vueVideoPlayer2.default);
_vue2.default.use(_vueAsyncComputed2.default);

// Js Vendors


// Stylesheets


// Nes front: TODO to move


// Layouts


// Pages


// Components

_vue2.default.use(_vueRouter2.default);

if (!window.GLOBAL_CONFIG.dico.config.farm1.id) {
    window.alert("Error: You must define at leat one Farm in config");
};

var routes = [{ path: "/", redirect: { path: window.GLOBAL_CONFIG.dico.config.farm1.id } }, { name: "farm", path: "/:slug", component: _FarmPage2.default }];

var router = new _vueRouter2.default({
    routes: routes
});

_vue2.default.component("farm-page", _FarmPage2.default);

// Init
new _vue2.default({
    el: "#app",
    components: {
        DefaultLayout: _DefaultLayout2.default
    },
    router: router,
    template: "<default-layout></default-layout>"
});


//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 367
// module chunks = 0